module.exports = __webpack_public_path__ + "static/media/img_map.19e1441e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/PC/@1x/img_map.png
// module id = 868
// module chunks = 0